// extracted by mini-css-extract-plugin
module.exports = {"container":"PostTitle_container__cnkIH","title":"PostTitle_title__klvzV"};